// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3kB4p","imageUploader":"EGiftCard_imageUploader__m5Psn"};